var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"produccion-item"},[_c('b-card',[_c('h4',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.resolvedTitle))]),_c('p',{staticClass:"mb-0 text-muted"},[_vm._v("Seccion en construccion.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }